import http from '@/api/http'
import { subdomain } from "@/utilities";
export default {
  location(id, data) {
    let _url = "/location/" + id;

    if (data.isCoords) {
      _url += "?lat=" + data.lat + "&lng=" + data.lng;
    } else if (data.postcode) {
      _url += "?postcode=" + data.postcode;
    }

    return http({
      url: _url,
      method: "get",
      headers: { "X-Subdomain": subdomain.get() },
    });
  },
  search(postcode) {
    return http({
      url: "/location?postcode=" + postcode + "&radius=10",
      method: "get",
      headers: { "X-Subdomain": subdomain.get() },
    });
  },
  categories(locationId) {
    let url = `/location/${locationId}/menulist`
    return http({
      url: url,
      method: "get",
      headers: {
        "X-Subdomain": subdomain.get(),
      },
    });
  },
  menuItem(locationId, menuItemId) {
    return http({
      url: `/location/${locationId}/menulist/${menuItemId}`,
      method: "get",
      headers: {
        "X-Subdomain": subdomain.get(),
      },
    });
  },
};